// v-dragscroll.js
const dragscroll = {
    mounted(el) {
      el.onmousedown = ev => {
        const disX = ev.clientX;
        const disY = ev.clientY;
        const originalScrollLeft = el.scrollLeft;
        const originalScrollTop = el.scrollTop;
        const originalScrollBehavior = el.style['scroll-behavior'];
        const originalPointerEvents = el.style['pointer-events'];
        el.style['scroll-behavior'] = 'auto';
        // console.log(originalScrollLeft);
  
        document.onmousemove = dv => {
          dv.preventDefault();
          const distanceX = dv.clientX - disX;
          const distanceY = dv.clientY - disY;
          el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY);
          
        };
  
        document.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
          el.style['scroll-behavior'] = originalScrollBehavior;
          el.style['pointer-events'] = originalPointerEvents;
        };
      };
    }
  };
  
  export default dragscroll;
  